import { createSlice } from "@reduxjs/toolkit";

const ccaa_slice = createSlice({
    name: "ccaa",
    initialState: {
        logout_action: false,
        organization_name_store: sessionStorage.getItem('organization_name'),
        home_page:{
            organization_name: '',
            inclusion_number: '',
            contact_name: '',
            address: '',
            phone_number: '',
            email: ''
        },
        annual_reporting_summary_store: {
            organization_name: sessionStorage.getItem('organization_name'),
            acres_enrolled: "",
            acres_target: "",
            acres_contributed: "",
            additional_explanation: ""
        },
        annual_net_conservation_store: {
            organization_name: sessionStorage.getItem('organization_name'),
            conservation_measures:[],
            conservation_measures_implementation: '',
            partners_overlap: '',
            supplement_measures:[],
            additional_supplement_conservation_measures: '',
            updates_to_section_7: [],
        },
        summary_effectiveness_store: {
            organization_name: sessionStorage.getItem('organization_name'),
            methods_effective_monitoring: '',
            monitoring_results_summary: '',
            adaptive_management_triggered:[],
            adaptive_management_actions: '',
            supplemental_effectiveness_monitoring: '',
        },
        upcoming_year_forecast_store: {
            organization_name: sessionStorage.getItem('organization_name'),
            anticipate_updates:'',
            suggestions_for_ccaa:'',
            general_comments:''
        },
        annual_net_conservation_checkboxes: {
            conservation_mowing: false,
            habitat_set_asides: false,
            targeted_herbicide: false,
            seeding_or_planting: false,
            brush_removal: false,
            prescribed_burning: false,
            prescribed_grazing: false,
            overwintering_protection: false,
            spatially_focused: false,
            incorporate_pollinator: false,
            invasive_species_prevention: false,
            additional_pollinator_habitat: false,
            promote_supplemental_pollinator: false,
            none: false,
            update_section_7_yes: false,
            update_section_7_no: false,
        },
        summary_effectiveness_checkboxes: {
            adaptive_management_actions_yes: false,
            adaptive_management_actions_no: false,
        },
        annual_net_conservation_files:{
            tracking_sheet: [],
            supporting_documents: [],
            updated_section_7_file: []
        },
        summary_effectiveness_files:{
            map_file: [],
            summary_tracking_sheet_file: []
        },
        upcoming_year_forecast_files:{
            supporting_documentation_file_upcoming: []
        }
    },
    reducers: {
        set_organization_name: (state, action) => {
            state.organization_name_store = action.payload;
        },
        set_logout_action: (state, action) => {
            state.logout_action = action.payload;
        },
        set_home_page: (state, action) => {
            state.home_page = action.payload;
        },
        reset_organization_name: (state) => {
            state.organization_name_store = ""
        },
        set_annual_reporting_summary: (state, action) => {
            state.annual_reporting_summary_store = action.payload;
        },
        set_supporting_documentation_file: (state, action) => {
            state.upcoming_year_forecast_store.supporting_documentation_file = action.payload;
        },
        set_supporting_documents: (state, action) => {
            state.annual_net_conservation_store.supporting_documents = action.payload;
        },
        set_updated_section_7_file: (state, action) => {
            state.annual_net_conservation_store.updated_section_7_file = action.payload;
        },
        set_map_file: (state, action) => {
            state.summary_effectiveness_store.map_file = action.payload;
        },
        set_tracking_sheet_file: (state, action) => {
            state.annual_net_conservation_store.tracking_sheet = action.payload;
        },
        set_summary_effectiveness_file: (state, action) => {
            state.summary_effectiveness_store.summary_tracking_sheet_file = action.payload;
        },
        reset_annual_reporting_summary: (state) => {
            state.annual_reporting_summary_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                acres_enrolled: "",
                acres_target: "",
                acres_contributed: "",
                additional_explanation: ""
            }},
        set_annual_net_conservation: (state, action) => {
            state.annual_net_conservation_store = action.payload;
        },
        reset_annual_net_conservation: (state) => {
            state.annual_net_conservation_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                conservation_measures:[],
                conservation_measures_implementation: '',
                partners_overlap: '',
                supplement_measures:[],
                additional_supplement_conservation_measures: '',
                updates_to_section_7: [],
            }
        },
        set_summary_effectiveness: (state, action) => {
            state.summary_effectiveness_store = action.payload;
        },
        reset_summary_effectiveness: (state) => {
            state.summary_effectiveness_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                methods_effective_monitoring: '',
                monitoring_results_summary: '',
                adaptive_management_triggered:[],
                adaptive_management_actions: '',
                supplemental_effectiveness_monitoring: '',
            }
        },

        set_upcoming_year_forecast: (state, action) => {
            state.upcoming_year_forecast_store = action.payload;
        },
        reset_upcoming_year_forecast: (state) => {
            state.upcoming_year_forecast_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                anticipate_updates:'',
                suggestions_for_ccaa:'',
                general_comments:'',
            }
        },
        reset_home_page: (state) => {
            state.home_page = {
                    organization_name: '',
                    inclusion_number: '',
                    contact_name: '',
                    address: '',
                    phone_number: '',
                    email: ''
            }
        },
        set_annual_net_conservation_checkboxes: (state, action) => {
            state.annual_net_conservation_checkboxes[action.payload.value.toLowerCase()] = !state.annual_net_conservation_checkboxes[action.payload.value.toLowerCase()];
        },
        set_annual_net_conservation_radio: (state, action) => {
            state.annual_net_conservation_checkboxes[action.payload.value.toLowerCase()] = action.payload.checked;
        },
        set_summary_effectiveness_checkboxes: (state, action) => {
            state.summary_effectiveness_checkboxes[action.payload.value.toLowerCase()] = !state.summary_effectiveness_checkboxes[action.payload.value.toLowerCase()];
        },
        set_summary_effectiveness_radio: (state, action) => {
            state.summary_effectiveness_checkboxes[action.payload.value.toLowerCase()] = action.payload.checked;
        },
        set_annual_net_conservation_files: (state, action) => {
            if(!state.annual_net_conservation_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.annual_net_conservation_files[action.payload.fileType.toLowerCase()] = state.annual_net_conservation_files[action.payload.fileType.toLowerCase()].concat(action.payload.fileName);
            }
        },
        remove_annual_net_conservation_files: (state, action) => {
            if(state.annual_net_conservation_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.annual_net_conservation_files[action.payload.fileType.toLowerCase()] = state.annual_net_conservation_files[action.payload.fileType.toLowerCase()].filter((file) => file !== action.payload.fileName);
            }
        },
        set_summary_effectiveness_files: (state, action) => {
            if(!state.summary_effectiveness_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.summary_effectiveness_files[action.payload.fileType.toLowerCase()] = state.summary_effectiveness_files[action.payload.fileType.toLowerCase()].concat(action.payload.fileName);
            }
        },
        remove_summary_effectiveness_files: (state, action) => {
            if(state.summary_effectiveness_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.summary_effectiveness_files[action.payload.fileType.toLowerCase()] = state.summary_effectiveness_files[action.payload.fileType.toLowerCase()].filter((file) => file !== action.payload.fileName);
            }
        },
        set_upcoming_year_forecast_files: (state, action) => {
            if(!state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()] = state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()].concat(action.payload.fileName);
            }
        },
        remove_upcoming_year_forecast_files: (state, action) => {
            if(state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()].includes(action.payload.fileName)){
                state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()] = state.upcoming_year_forecast_files[action.payload.fileType.toLowerCase()].filter((file) => file !== action.payload.fileName);
            }
        },
        reset_ccca_slice: (state) => {
            state.logout_action = false;
            state.organization_name_store = "";
            state.annual_reporting_summary_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                acres_enrolled: "",
                acres_target: "",
                acres_contributed: "",
                additional_explanation: ""
            };
            state.annual_net_conservation_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                conservation_measures:[],
                conservation_measures_implementation: '',
                partners_overlap: '',
                supplement_measures:[],
                additional_supplement_conservation_measures: '',
                updates_to_section_7: [],
            };
            state.summary_effectiveness_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                methods_effective_monitoring: '',
                monitoring_results_summary: '',
                adaptive_management_triggered:[],
                adaptive_management_actions: '',
                supplemental_effectiveness_monitoring: '',
            };
            state.upcoming_year_forecast_store = {
                organization_name: sessionStorage.getItem('organization_name'),
                anticipate_updates:'',
                suggestions_for_ccaa:'',
                general_comments:''
            };
            state.annual_net_conservation_checkboxes = {
                conservation_mowing: false,
                habitat_set_asides: false,
                targeted_herbicide: false,
                seeding_or_planting: false,
                brush_removal: false,
                prescribed_burning: false,
                prescribed_grazing: false,
                overwintering_protection: false,
                spatially_focused: false,
                incorporate_pollinator: false,
                invasive_species_prevention: false,
                additional_pollinator_habitat: false,
                promote_supplemental_pollinator: false,
                none: false,
                update_section_7_yes: false,
                update_section_7_no: false,
            };
            state.summary_effectiveness_checkboxes = {
                adaptive_management_actions_yes: false,
                adaptive_management_actions_no: false,
            };
            state.annual_net_conservation_files = {
                tracking_sheet: [],
                supporting_documents: [],
                updated_section_7_file: []
            };
            state.summary_effectiveness_files = {
                map_file: [],
                summary_tracking_sheet_file: [],
            };
            state.upcoming_year_forecast_files = {
                supporting_documentation_file_upcoming: [],
            };
        },
        reset_checkboxes: (state) => {
            state.annual_net_conservation_checkboxes = {
                conservation_mowing: false,
                habitat_set_asides: false,
                targeted_herbicide: false,
                seeding_or_planting: false,
                brush_removal: false,
                prescribed_burning: false,
                prescribed_grazing: false,
                overwintering_protection: false,
                spatially_focused: false,
                incorporate_pollinator: false,
                invasive_species_prevention: false,
                additional_pollinator_habitat: false,
                promote_supplemental_pollinator: false,
                none: false,
                update_section_7_yes: false,
                update_section_7_no: false,
            };
            state.summary_effectiveness_checkboxes = {
                adaptive_management_actions_yes: false,
                adaptive_management_actions_no: false,
            }
        },
        convert_to_string_conservation_measures: (state) => {
            state.annual_net_conservation_store.conservation_measures = state.annual_net_conservation_store.conservation_measures.toString();
        },
        convert_to_string_supplement_measures: (state) => {
            state.annual_net_conservation_store.supplement_measures = state.annual_net_conservation_store.supplement_measures.toString();
        },
        convert_to_string_updates_to_section_7: (state) => {
            state.annual_net_conservation_store.updates_to_section_7 = state.annual_net_conservation_store.updates_to_section_7.toString();
        },
        convert_to_string_adaptive_management_triggered: (state) => {
            state.summary_effectiveness_store.adaptive_management_triggered = state.summary_effectiveness_store.adaptive_management_triggered.toString();
        },
        convert_to_array_conservation_measures: (state) => {
            //if empty string, set to empty array
            if (state.annual_net_conservation_store.conservation_measures === '') {
                state.annual_net_conservation_store.conservation_measures = [];
            }
            state.annual_net_conservation_store.conservation_measures = state.annual_net_conservation_store.conservation_measures.split(',');
        },
        convert_to_array_supplement_measures: (state) => {
            //if empty string, set to empty array
            if (state.annual_net_conservation_store.supplement_measures === '') {
                state.annual_net_conservation_store.supplement_measures = [];
            }
            state.annual_net_conservation_store.supplement_measures = state.annual_net_conservation_store.supplement_measures.split(',');
        },
        convert_to_array_updates_to_section_7: (state) => {
            //if empty string, set to empty array
            if (state.annual_net_conservation_store.updates_to_section_7 === '') {
                state.annual_net_conservation_store.updates_to_section_7 = [];
            }
            state.annual_net_conservation_store.updates_to_section_7 = state.annual_net_conservation_store.updates_to_section_7.split(',');
        },
        convert_to_array_adaptive_management_triggered: (state) => {
            //if empty string, set to empty array
            if (state.summary_effectiveness_store.adaptive_management_triggered === '') {
                state.summary_effectiveness_store.adaptive_management_triggered = [];
            }
            state.summary_effectiveness_store.adaptive_management_triggered = state.summary_effectiveness_store.adaptive_management_triggered.split(',');
        }
    }
}
);

export const ccaa_actions = ccaa_slice.actions;
export default ccaa_slice;
